"use client";

import { motion } from "framer-motion";

// Benefit list item component
const BenefitItem = ({ title, description }) => (
	<li className="flex items-start">
		<svg
			className="w-6 h-6 text-[#819f3d] mr-2 mt-0.5 flex-shrink-0"
			fill="none"
			stroke="currentColor"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M5 13l4 4L19 7"
			/>
		</svg>
		<div>
			<span className="font-semibold text-gray-800">{title}</span>
			<p className="text-gray-600">{description}</p>
		</div>
	</li>
);

// Benefit data
const benefits = [
	{
		title: "Global Networking Opportunities",
		description:
			"Connect with a diverse community of leaders and diplomats from around the world",
	},
	{
		title: "Priority Access to International Conferences",
		description:
			"Attend exclusive events and workshops with renowned speakers and experts in the field",
	},
	{
		title: "Certification and Training Programs",
		description:
			"Enhance your skills and knowledge through specialized training sessions and workshops",
	},
	{
		title: "Mentorship by Global Experts",
		description:
			"Receive guidance and support from experienced leaders and diplomats in your field of interest",
	},
	{
		title: "Recognition and Awards",
		description:
			"Be recognized for your contributions and achievements in the field of leadership and diplomacy",
	},
	{
		title: "Opportunity to Contribute to Global Policy Dialogues",
		description:
			"Engage in discussions and initiatives that shape global policies and practices",
	},
	{
		title: "Access to SLD Research & Publications",
		description:
			"Stay updated with the latest research and publications in the field of leadership and diplomacy",
	},
	{
		title: "Participation in Cultural Exchange Programs",
		description:
			"Experience diverse cultures and perspectives through exchange programs and international collaborations",
	},
	{
		title: "Exclusive Discounts on Events and Merchandise",
		description:
			"Enjoy special rates on conferences, workshops, and SLD merchandise",
	},
	{
		title: "Leadership and Representation Opportunities",
		description:
			"Engage in leadership roles within the SLD community and represent SLD at various platforms",
	},
];

const Admissions = () => {
	return (
		<div className="bg-white pt-20">
			{/* Hero Section */}
			<section className="relative py-20 bg-[#819f3d] text-white text-center">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<motion.h1
						initial={{ y: -20, opacity: 0 }}
						animate={{ y: 0, opacity: 1 }}
						transition={{ duration: 0.8 }}
						className="text-4xl md:text-5xl font-bold mb-6">
						Join Us and Shape the Future
					</motion.h1>
				</div>
			</section>

			{/* Benefits Section */}
			<section className="py-16">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<motion.div
						initial={{ opacity: 0, y: 20 }}
						whileInView={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.8 }}>
						<h2 className="text-3xl font-bold text-[#1666ba] mb-8">
							As a member, you will receive the following benefits:
						</h2>
						<div className="bg-white p-8 rounded-lg shadow-lg">
							<ul className="space-y-4">
								{benefits.map((benefit, index) => (
									<BenefitItem
										key={index}
										title={benefit.title}
										description={benefit.description}
									/>
								))}
							</ul>
						</div>
					</motion.div>
				</div>
			</section>
		</div>
	);
};

export default Admissions;
